export type CustomerOrderDetailLabels = {
  orderPrefix: string
  orderPlaced: string
  internalRef: string
  paidWithPrefix: string
  statusTitle: string
  statusSubtitle: string
  statusCurrent: string
  statusDescriptionCreated: string
  statusDescriptionPaid: string
  statusDescriptionShipped: string
  statusDescriptionCancelled: string
  statusCancelled: string
  stepCreated: string
  stepPaid: string
  stepShipped: string
  productsTitle: string
  summaryTitle: string
  shippingTitle: string
  shippingMissing: string
  shippingMissingTitle: string
  shippingCost: string
  qty: string
  trackOrder: string
  requestSupport: string
  supportAsideTitle: string
  supportContextHint: string
  inTransit: string
}

export const buildCustomerOrderDetailLabels = (language: 'it' | 'en'): CustomerOrderDetailLabels => {
  const isItalian = language === 'it'

  return {
    orderPrefix: isItalian ? 'Ordine' : 'Order',
    orderPlaced: isItalian ? 'Ordine effettuato il' : 'Placed on',
    internalRef: isItalian ? 'Riferimento ordine' : 'Order reference',
    paidWithPrefix: isItalian ? 'Pagato' : 'Paid',
    statusTitle: isItalian ? 'Stato ordine' : 'Order status',
    statusSubtitle: isItalian
      ? 'Controlla rapidamente dove si trova il tuo ordine.'
      : 'Quickly check where your order is right now.',
    statusCurrent: isItalian ? 'Stato attuale' : 'Current status',
    statusDescriptionCreated: isItalian ? 'Il tuo ordine e in preparazione.' : 'Your order is currently being prepared.',
    statusDescriptionPaid: isItalian
      ? 'Pagamento confermato, stiamo preparando la spedizione.'
      : 'Payment confirmed, we are preparing shipment.',
    statusDescriptionShipped: isItalian ? 'Ordine spedito, in consegna.' : 'Order shipped, currently in transit.',
    statusDescriptionCancelled: isItalian
      ? 'Ordine annullato. Se serve, possiamo aiutarti con l assistenza.'
      : 'Order cancelled. Contact support if you need help.',
    statusCancelled: isItalian
      ? 'Ordine annullato. Per assistenza puoi aprire una richiesta dedicata.'
      : 'Order cancelled. Contact support for additional help.',
    stepCreated: isItalian ? 'Ordine creato' : 'Order created',
    stepPaid: isItalian ? 'Pagamento confermato' : 'Payment confirmed',
    stepShipped: isItalian ? 'Spedito' : 'Shipped',
    productsTitle: isItalian ? 'Prodotti acquistati' : 'Purchased products',
    summaryTitle: isItalian ? 'Riepilogo pagamento' : 'Payment summary',
    shippingTitle: isItalian ? 'Indirizzo di spedizione' : 'Shipping address',
    shippingMissingTitle: isItalian ? 'Nessun indirizzo disponibile' : 'Shipping address unavailable',
    shippingMissing: isItalian
      ? 'I dati di spedizione non sono disponibili per questo ordine.'
      : 'Shipping details are not available for this order.',

    shippingCost: isItalian ? 'Spedizione' : 'Shipping',
    qty: isItalian ? 'Quantita' : 'Qty',
    trackOrder: isItalian ? 'Traccia ordine' : 'Track order',
    requestSupport: isItalian ? 'Richiedi supporto' : 'Request support',
    supportAsideTitle: isItalian ? 'Hai bisogno di aiuto?' : 'Need help?',
    supportContextHint: isItalian
      ? 'Apriremo l assistenza con ordine, stato e prodotto principale gia precompilati.'
      : 'Support opens with order, status, and main product prefilled.',
    inTransit: isItalian ? 'In transito' : 'In transit',
  }
}
